<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="90px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺别名">
                  <el-select v-model="queryForm.vendorAliasId" filterable clearable>
                    <el-option v-for="item in vendorAliasList" :label="item.vendorNameAlias" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="Vendor ID">
                  <el-input type="number" v-model.number="queryForm.inputVendorId" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店名称">
                  <el-select v-model="queryForm.vendorId" filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div>
      <el-button type="primary" @click="showForm">新增配置</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="vendorId" label="Vendor ID"></el-table-column>
      <el-table-column prop="vendorName" label="买手店">
        <template slot-scope="scope">
          {{ scope.row.vendorName }}
          <p>/</p>
          {{ scope.row.vendorNameAlias }}
        </template>
      </el-table-column>
      <el-table-column label="展示售后订单到Portal">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.openTime) }} ~ {{ scope.row.endTime ? dateFormat(scope.row.endTime) : '不限' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" @click="showEditAccount(scope.row)">终止显示</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body :title="form.vendorBlackWhiteNameConfigId ? '终止售后白名单' : '新增售后白名单'" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item label="买手店名称" prop="vendorId" :rules="[{ required: true, message: '请选择账户名称' }]">
          <el-select v-model="form.vendorId" :disabled="form.vendorBlackWhiteNameConfigId" filterable>
            <el-option v-for="item in vendorAliasList" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <p class="mb10">展示售后订单到Portal：</p>
        <el-form-item label="开始展示时间" prop="openTime" :rules="[{ required: true, message: '请选择开始展示时间' }]">
          <el-date-picker
              v-model="form.openTime"
              type="datetime"
              :editable="false"
              :clearable="false"
              value-format="timestamp"
              style="width: 100%"
              :disabled="form.vendorBlackWhiteNameConfigId"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="form.vendorBlackWhiteNameConfigId" label="结束展示时间" prop="endTime" :rules="[{ required: true, message: '请选择结束展示时间' }]">
          <el-date-picker
              v-model="form.endTime"
              type="datetime"
              :editable="false"
              :clearable="false"
              value-format="timestamp"
              style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getVendorList,
  vendorAfterSaleWhiteList,
  addVendorAfterSaleWhiteList,
  updateVendorAfterSaleWhiteList,
} from "./api";
import utils from '@/utils/util';

export default {
  data() {
    return {
      vendorAliasList: [],
      queryForm: {
        vendorAliasId: null,
        inputVendorId: null,
        vendorId: null,
        pageNo: 1,
        pageSize: 25,
      },
      vendorList: [],
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: {
        vendorBlackWhiteNameConfigId: null,
        vendorId: null,
        openTime: null,
        endTime: null,
      },
    };
  },
  mounted() {
    getVendorList(true).then(res => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data.map(item => ({
          value: item.vendorId,
          label: item.vendorName,
        }));
        this.vendorAliasList = (res.data.data || []).map(item => ({
          label: `${item.vendorNameAlias} - ${item.vendorName}`,
          value: item.vendorId,
          vendorNameAlias: item.vendorNameAlias,
        }));
      }
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorAliasId = null;
      this.queryForm.inputVendorId = null;
      this.queryForm.vendorId = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      vendorAfterSaleWhiteList({
        ...this.queryForm,
        vendorId: this.queryForm.inputVendorId || this.queryForm.vendorAliasId || this.queryForm.vendorId,
      }).then(res => {
        if (res.data) {
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.vendorBlackWhiteNameConfigId && this.form.endTime <= this.form.openTime) {
            this.$message.error('结束时间必须大于开始时间');
            return;
          }
          if (!this.repeatSave) {
            this.repeatSave = true;
            let request = addVendorAfterSaleWhiteList;
            if (this.form.vendorBlackWhiteNameConfigId) {
              request = updateVendorAfterSaleWhiteList;
            }
            request(this.form).then(res => {
              this.repeatSave = false;
              if (res.success) {
                this.$message.success(this.form.vendorBlackWhiteNameConfigId ? '变更成功' : '新增成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.message || '系统异常，请稍后再试');
              }
            }).catch((err) => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    showForm() {
      this.form.vendorBlackWhiteNameConfigId = null;
      this.form.vendorId = null;
      this.form.openTime = null;
      this.form.endTime = null;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    showEditAccount(row) {
      this.form.vendorBlackWhiteNameConfigId = row.vendorBlackWhiteNameConfigId;
      this.form.vendorId = row.vendorId;
      this.form.openTime = row.openTime;
      this.form.endTime = row.endTime || null;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.store-wrap {
  max-height: 500px;
  overflow: auto;
}
.store-list {
  display: flex;
  margin-bottom: 2px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;

  .store-name {
    flex: 0 0 auto;
    width: 150px;
    padding: 10px;
    border-right: 1px solid #DCDFE6;
  }
  .store-stocklocation-list {
    padding: 10px;
  }
}
.sl-group {
  display: flex;
  flex-wrap: wrap;

  .sl-item {
    margin-right: 10px;
    margin-top: 10px;
    padding: 0 5px;
    line-height: 30px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .icon-close:hover {
    color: #409EFF;
  }
}
.vendor-name {
  white-space:nowrap;
  text-overflow:ellipsis;
  overflow:hidden; 
}
</style>
